module.exports = __webpack_public_path__ + "img/logo-selvaalegre.74ce3e3d.png";